import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
    Table,
} from 'reactstrap';

import { getPpwrRequirementStatusConfig, getPpwrRiskConfig } from 'src/modules/3rd-party-management/constants';
import RedFlagIcon from 'src/modules/3rd-party-management/components/RedFlagIcon';

import useRequirementTracker from './hooks/useRequirementTracker';

const RequirementTrackerSkeleton = () => (
    <Card className="h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '30%', height: '24px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '220px' }} />
        </CardBody>
    </Card>
);

const RequirementTracker = ({
    t,
}) => {
    const {
        data: requirements,
        isLoading,
        isFetching,
        isError,
    } = useRequirementTracker({ t });

    if (isLoading || isFetching) {
        return <RequirementTrackerSkeleton />;
    }

    if (isError || !requirements) {
        return null;
    }

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardTitle tag="h6" className="mb-4">
                    {t('PPWR Requirement Tracker')}
                </CardTitle>

                <div className="table-responsive">
                    {!requirements.length ? (
                        <div className="text-center py-4 text-muted">
                            {t('No requirements available.')}
                        </div>
                    ) : (
                        <Table className="mb-0" responsive borderless> 
                            <thead>
                                <tr>
                                    <th>{t('Requirements')}</th>
                                    <th>{t('Risk Level')}</th>
                                    <th>{t('Status')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requirements.map((item) => {
                                    const riskConfig = getPpwrRiskConfig(item.riskLevel);
                                    const statusConfig = getPpwrRequirementStatusConfig(item.status);

                                    return (
                                        <tr key={item.id}>
                                            <td>{t(item.requirement)}</td>
                                            <td>
                                                <span style={{ color: riskConfig.hex }}>
                                                    {t(riskConfig.label)}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <RedFlagIcon isFlagged={statusConfig.isFlagged} />
                                                    <span>{t(statusConfig.label)}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(RequirementTracker);
